import { FC } from 'react';
import TextInput from 'components/ui/TextInput';
import { FormikProps } from 'formik';
import { ICourseCategoryInput } from 'redux/reducers/courseCategory';
import { ICertificateSignatureInput } from './schema';
import { backendURL } from 'redux/reducers/settings';
interface ITrainingForm {
  formik: FormikProps<ICertificateSignatureInput>;
}
const CertificateSignatureForm: FC<ITrainingForm> = ({ formik }) => {
  return (
    <form>
      <div className="row">
        <TextInput
          label="Full Name"
          name="full_name"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.full_name}
          onBlur={formik.handleBlur}
          formik={formik}
        />

        <TextInput
          // containerClassName="mt-3 "
          label="Position"
          name="position"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.position}
          onBlur={formik.handleBlur}
          formik={formik}
        />

        <div className="col-6">
          signature
          <div className="">
            <input
              id="profile-img-file-input"
              type="file"
              className="profile-img-file-input"
              name="image"
              onChange={(e) => {
                formik.setFieldValue('signature', e.target.files?.[0] || '');
              }}
            />
            <img
              src={formik?.values?.signature ? backendURL + '/' + formik?.values?.signature : ''}
              className="  img-thumbnail "
              alt="signature"
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default CertificateSignatureForm;
